import { render, staticRenderFns } from "./ReceiptIncome.vue?vue&type=template&id=e4db61f8&scoped=true"
import script from "./ReceiptIncome.vue?vue&type=script&lang=js"
export * from "./ReceiptIncome.vue?vue&type=script&lang=js"
import style0 from "./ReceiptIncome.vue?vue&type=style&index=0&id=e4db61f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4db61f8",
  null
  
)

export default component.exports